import { httpClient } from '@/shared/utils/http-client'

export interface PhotoUploadResponse {
  url: string
  s3Url: string
  buildingUuid: string
  fileName: string
}

export interface PhotoDeleteResponse {
  code: number
  message: string
}

const EB_HUB_API_BASE_URL = import.meta.env.DEV
  ? `/eb-hub-service/eb-hub/v1`
  : 'https://eb-hub-service.enter.de/eb-hub/v1'

class BuildingPhotosApi {
  async uploadPhoto(file: File, buildingUuid: string): Promise<PhotoUploadResponse> {
    const url = `${EB_HUB_API_BASE_URL}/building/${buildingUuid}/photo`
    return await httpClient.uploadFile<PhotoUploadResponse>(url, file)
  }

  uploadPhotoWithProgress(
    file: File,
    buildingUuid: string,
    onProgress?: (progress: number) => void
  ): { promise: Promise<PhotoUploadResponse>; abort: () => void } {
    const url = `${EB_HUB_API_BASE_URL}/building/${buildingUuid}/photo`
    return httpClient.uploadFileWithProgress<PhotoUploadResponse>(url, file, undefined, onProgress)
  }

  async deletePhoto(buildingUuid: string, fileName: string): Promise<PhotoDeleteResponse | null> {
    const url = `${EB_HUB_API_BASE_URL}/building/${buildingUuid}/photo/${fileName}`
    return await httpClient.delete<PhotoDeleteResponse>(url)
  }

  getPhotoUrl(buildingUuid: string, fileName: string): string {
    return `${EB_HUB_API_BASE_URL}/building/${buildingUuid}/photo/${fileName}`
  }
}

export const buildingPhotosApi = new BuildingPhotosApi()
